module.exports = __webpack_public_path__ + "static/media/NaktoLogo.5c975fde.webp";